import Vue from 'vue';
import App from '@/App';

import '@/components/index';
import '@/plugins/vuelidate';

import '@/assets/tailwind.css'; // Must be before any other custom CSS
import store from '@/store/index';
import router from '@/router/index';
import i18n from '@/i18n';

import './assets/tailwind.css';
import {initUTMTracking} from "@/utils/analytics";

Vue.config.productionTip = false;

initUTMTracking();

new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app');
